// components
import CommonActionModal from "../Common/CommonActionModal";
import CommentForm from "./CommentForm";

// icons
import ReplyIcon from '@mui/icons-material/Reply';


class CommentReplyModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: ReplyIcon,
            buttonColor: 'neutral',
            modalLabel: 'Добавить комментарий',
            modalIcon: ReplyIcon,
            mainComponent: CommentForm,
            width: 'calc(80vw)',
            height: '500px',
            mainComponentProps: {
                appName: this.props.appName,
                appId: this.props.appId,
                replyTo: this.props.replyTo,
                value: '@' + this.props.replyTo.owner.username,
                inlineReply: true,
                callBack: this.callBack.bind(this),
            },
            ready: true,
        })
    }

    async callBack(comment) {
        if (this.props.callBack){
            await this.props.callBack(comment);
        }
        await this.setModalOpenFalse()
    }
}

export default CommentReplyModal
